module.exports = __webpack_public_path__ + "img/hair_color_platinum.4ac5dba.svg";